import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/LEARNING_JOURNEY';

export const {action: togglePrintForm} = createAction(`${domain}/TOGGLE_PRINT_FORM`, (show, variants, limitPrint) => ({
    show,
    variants,
    limitPrint,
}));
